import { render, staticRenderFns } from "./Notifies.vue?vue&type=template&id=6c4c7cfd&"
import script from "./Notifies.vue?vue&type=script&lang=js&"
export * from "./Notifies.vue?vue&type=script&lang=js&"
import style0 from "./Notifies.vue?vue&type=style&index=0&id=6c4c7cfd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports